/**
 * Mirrors `App\Enum\BreakRuleType` on the backend and the generated `BreakRuleType` string alias in the
 * API client (hence the `Base` prefix — both are exported from the library's public API). `None` is the
 * explicit, configured zero-minute break — distinct from a duty-model day with no break rule at all (null),
 * which also computes to 0 but means "not configured".
 */
export enum BaseBreakRuleType {
  None = 'none',
  FixedDeduction = 'fixed_deduction',
  StaggeredByHours = 'staggered_by_hours',
  FixedClockTimes = 'fixed_clock_times',
}
